import React from 'react';

/**
 * Favicon.
 */
export function Favicon({ href }) {
    return <link rel="icon" type={type} href={href} sizes="128x128" />;
}
